import {Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: "app-detail-promotion",
    templateUrl: "./detail-promotion.component.html",
    styleUrls: ["./detail-promotion.component.scss"]
})
export class DetailPromotionComponent {

    promotionKey;
    promotionType;

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute.params.subscribe((param) => {
            this.promotionKey = param['promotionKey'];
            this.promotionType = param['promotionType'];
        });
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/detail-promotion/detail-promotion.component.ts